import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import axios from "axios";

// Context
import { CartProvider } from "@/context/CartContext";
import { AuthProvider } from "@/context/AuthContext";
import { WishlistProvider } from "@/context/WishlistContext";

// Pages
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import AboutPage from "@/pages/AboutPage";
import PartnerPage from "@/pages/PartnerPage";
import ProductDetail from "@/pages/ProductDetail";
import AdminPage from "@/pages/AdminPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrdersPage from "@/pages/OrdersPage";
import AuthCallback from "@/pages/AuthCallback";
import WishlistPage from "@/pages/WishlistPage";
import TermsPage from "@/pages/TermsPage";
import PrivacyPage from "@/pages/PrivacyPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import ShippingPolicyPage from "@/pages/ShippingPolicyPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import ResumeCartPage from "@/pages/ResumeCartPage";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import AdminRoute from "@/components/AdminRoute";
import AnnouncementBanner from "@/components/AnnouncementBanner";
import AgeGate from "@/components/AgeGate";

var API = "/api";

function App() {
  useEffect(function seedProducts() {
    axios.post(API + "/seed-products").catch(function() {});
  }, []);

  return (
    <HelmetProvider>
    <AuthProvider>
      <WishlistProvider>
        <CartProvider>
          <div className="App min-h-screen bg-[#0a0a0a]">
            <div className="noise-overlay" aria-hidden="true" />
            <BrowserRouter>
              <AgeGate />
              <AnnouncementBanner />
              <Navbar />
              <CartDrawer />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/shop" element={<ShopPage />} />
                  <Route path="/shop/:productId" element={<ProductDetail />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/partner-program" element={<PartnerPage />} />
                  <Route path="/admin" element={<AdminRoute><AdminPage /></AdminRoute>} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/checkout/success" element={<CheckoutPage />} />
                  <Route path="/checkout/cancel" element={<CheckoutPage />} />
                  <Route path="/orders" element={<OrdersPage />} />
                  <Route path="/track-order" element={<TrackOrderPage />} />
                  <Route path="/resume-cart" element={<ResumeCartPage />} />
                  <Route path="/wishlist" element={<WishlistPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/refund-policy" element={<RefundPolicyPage />} />
                  <Route path="/shipping-policy" element={<ShippingPolicyPage />} />
                  <Route path="/auth/callback" element={<AuthCallback />} />
                </Routes>
              </main>
              <Footer />
            </BrowserRouter>
            <Toaster position="bottom-right" theme="dark" />
          </div>
        </CartProvider>
      </WishlistProvider>
    </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
